import { render, staticRenderFns } from "./allemergencyEvent.vue?vue&type=template&id=5fe7d4d4&scoped=true"
import script from "./allemergencyEvent.vue?vue&type=script&lang=js"
export * from "./allemergencyEvent.vue?vue&type=script&lang=js"
import style0 from "./allemergencyEvent.vue?vue&type=style&index=0&id=5fe7d4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe7d4d4",
  null
  
)

export default component.exports